import React from 'react';
import { SectionTitle } from '../../common/SectionTitle';
import { RealEstateAgentCard } from '../../common/RealEstateAgentCard';
import { RealEstateAgent } from '../../../utility/types';

type PropertyDetailAgentDisplayProps = {
  listingAgent?: RealEstateAgent;
  publicRemarks?: string;
};

export const PropertyDetailAgentDisplay = ({
  listingAgent,
  publicRemarks,
}: PropertyDetailAgentDisplayProps) => {
  if (!listingAgent && !publicRemarks) return null;

  return (
    <>
      <div className="flex flex-wrap lg:grid lg:grid-cols-2 gap-6">
        {listingAgent && (
          <div>
            <SectionTitle title="Presented By" />
            <RealEstateAgentCard agent={listingAgent} />
          </div>
        )}
        {publicRemarks && (
          <div>
            <SectionTitle title="Public Remarks" />
            <p className="whitespace-pre-line mt-2">{publicRemarks}</p>
          </div>
        )}
      </div>
      <hr className="h-1.5 mt-6 bg-violet-100" />
    </>
  );
};
